import _ from "lodash";


const transformValueFormData = (value) => {
  if (_.isBoolean(value)) {
    return value ? "1" : "0";
  }

  if (typeof value === 'object' && value instanceof Date) {
    return value.toISOString();
  }

  return value;
}

export function getFormData(obj) {
  const formData = new FormData();
  Object.keys(obj).forEach(key => {
    const value = transformValueFormData(obj[key]);
    if (value !== undefined && value !== null) formData.append(key, value);
  });
  return formData;
}

